<template>
    <div class="container">
        <div class="meet-level trans">
            <meet-header
                :headerConfig="headerConfig"
                @handleClickIocn="handleClickIocn"
            />

            <div class="main">
                <h2 class="tit">会场信息</h2>
                <!-- <div class="meet-notice-list" v-for="(item,i) in informList" :key="i">
                    <div @click="handleDetails(item)" class="item shadow"><span class="notice-tit">{{item.name}}</span><span class="time">查看详情</span></div>    
                </div> -->
                <div class="meet-notice-list">
                    <div @click="handleDetails('traffic')" class="item shadow"><span class="notice-tit">交通信息</span><span class="time">查看详情</span></div>    
                    <div @click="handleDetails('introduction')" class="item shadow"><span class="notice-tit">会场介绍</span><span class="time">查看详情</span></div>
                    <!-- <div @click="handleDetails('tranship')" class="item shadow"><span class="notice-tit">接驳安排</span><span class="time">查看详情</span></div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import meetHeader from "@/components/header";
import CurrentConferMixin from "@/mixin/CurrentConference"

export default {
    name: "meetLevel",
    components: {
        meetHeader,
    },
    mixins: [CurrentConferMixin],
    data() {
        return {
            headerConfig: {
                headerIcon: "city ct-xiangyou",
                headerTitle: "会议概况信息",
            },

        };

    },
    created(){

    },
    methods: {
        handleClickIocn() {
            history.go(-1);
        },
        handleDetails(param){
            
            if(param == 'traffic'){
                if (this.currentConference.places.length>0 && this.currentConference.places[0].traffic !=null && this.currentConference.places[0].traffic !=''){
                    this.$router.push({ name: "trafficdetail"})
                }else{
                    this.$message('暂无交通信息');
                }
                
            }
            if(param == 'introduction'){
                if (this.currentConference.places.length>0 && this.currentConference.places[0].introduction !=null && this.currentConference.places[0].introduction !=''){
                    this.$router.push({ name: "introdetail"})
                }else{
                    this.$message('暂无介绍信息');
                }
                
            }   
            if(param == 'tranship'){
                if (this.currentConference.places.length>0 && this.currentConference.places[0].tranship !=null && this.currentConference.places[0].tranship !=''){
                    this.$router.push({ name: "transhipdetail"})
                }else{
                    this.$message('暂无接驳安排信息');
                }
                
            }        
        }
    },
};
</script>

<style lang="scss" scoped>
.main {
    width: 100%;
    padding: 0 15px;
    margin-bottom: 30px;
    box-sizing: border-box;

    .tit {
        padding-left: 8px;
        margin-top: 30px;
        border-left: 4px solid var(--main-color);
        font-size: 18px;
        font-weight: bold;
        color: var(--main-color);
    }

   
    .meet-notice-list {
        width: 100%;
        margin-top: 30px;

        .item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px;
            height: 30px;
            border-radius: 5px;
            margin-bottom: 15px;

            &:last-child {
                margin-bottom: 0;
            }

            .notice-tit {
                font-size: 14px;
            }

            .time {
                font-size: 12px;
            }
        }
    }
}
</style>